/**
 * Store: Personalization
 * -----------------------------------------------------------------------------
 * Personalization states
 * Data that is used for shopper personalization
 *
 * - Only JSDOC custom parameters, ignore module state or object.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    recentlyViewedProducts: [],
    recentSearches: [],
  }),

  mutations: {

    /**
     * Set recent searches to state
     * @param {string} searches
     */
    SET_RECENT_SEARCHES(state, searches) {
      state.recentSearches = searches.slice(0, 3)
    },

    /**
     * Set recently viewed product in array
     * @param {Object} products
     */
    SET_RECENTLY_VIEWED_PRODUCTS(state, products) {
      state.recentlyViewedProducts = products.slice(0, 10)
    },
  },

  actions: {

    /**
     * Commit recent search query
     * @param {string} query
     */
    addRecentSearch({ commit, state }, query) {
      const searches = state.recentSearches.slice()
      if (!query || searches.some(search => search.query === query)) {
        return
      }
      searches.unshift({ query })
      commit('SET_RECENT_SEARCHES', searches)
    },

    /**
     * Commit recently viewed product
     * @param product
     */
    addRecentlyViewedProduct({ commit, state }, product) {
      const products = state.recentlyViewedProducts.slice()
      if (!product || products.some(viewedProduct => viewedProduct.id === product.id)) {
        return
      }
      products.unshift({ ...product })

      commit('SET_RECENTLY_VIEWED_PRODUCTS', products)
    },

    /**
     * Clear recently viewed products
     */
    clearRecentlyViewedProducts({ commit }) {
      commit('SET_RECENTLY_VIEWED_PRODUCTS', [])
    },

    /**
     * Commit removal of recent search query
     * @param {string} query
     */
    removeRecentSearch({ commit, state }, query) {
      const index = state.recentSearches.findIndex(search => search.query === query)
      if (index < 0) {
        return
      }
      const searches = state.recentSearches.slice()
      searches.splice(index, 1)
      commit('SET_RECENT_SEARCHES', searches)
    },
  },
}
